var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "file-loader" },
    [
      _c(
        "transition-group",
        {
          staticClass: "file-loader__items",
          attrs: { duration: _vm.duration, tag: "div", name: "fade" },
        },
        [
          _vm._l(_vm.linksList, function (link) {
            return _c(
              "div",
              { key: link.id, staticClass: "file-loader-item" },
              [
                _c("file-preview", {
                  attrs: {
                    type: link.type,
                    url: link.url,
                    name: link.name,
                    actions: _vm.actions,
                    "data-type": "link",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showGallery(link)
                    },
                  },
                }),
                !_vm.disabled
                  ? _c("c-button", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.html",
                          value: {
                            container: "#app",
                            trigger: "hover blur",
                            content: "Удалить",
                            placement: "top",
                          },
                          expression:
                            "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                          modifiers: { html: true },
                        },
                      ],
                      staticClass: "file-loader-item__remove",
                      attrs: { size: "iconic", icon: "trash" },
                      on: {
                        click: function ($event) {
                          return _vm.removeLink(link)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm._l(_vm.files, function (file) {
            return _c(
              "div",
              { key: file.id, staticClass: "file-loader-item" },
              [
                _c("file-preview", {
                  attrs: {
                    type: file.type,
                    url: file.url,
                    name: file.name,
                    actions: _vm.actions,
                    "data-type": "file",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showGallery(file)
                    },
                  },
                }),
                !_vm.disabled
                  ? _c("c-button", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.html",
                          value: {
                            container: "#app",
                            trigger: "hover blur",
                            content: "Удалить",
                            placement: "top",
                          },
                          expression:
                            "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                          modifiers: { html: true },
                        },
                      ],
                      staticClass: "file-loader-item__remove",
                      attrs: { size: "iconic", icon: "trash" },
                      on: {
                        click: function ($event) {
                          return _vm.removeFile(file)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c("input", {
        ref: "input",
        attrs: {
          name: "attachment[]",
          multiple: _vm.limit > 1,
          type: "file",
          accept: _vm.inputAccept,
          hidden: "",
        },
        on: { change: _vm.onFileChange },
      }),
      _c(
        "div",
        { staticClass: "file-loader__footer" },
        [
          _c("c-button", {
            staticClass: "file-loader__add",
            class: {
              "file-loader__add--error": _vm.errors.length,
            },
            attrs: {
              disabled: _vm.disabled || _vm.limitReached,
              "data-slide": _vm.slide,
              size: "small",
              icon: { icon: "plus", color: "primary" },
              label: _vm.addFileLabel || "Добавить файл",
            },
            on: {
              click: function ($event) {
                return _vm.chooseFiles()
              },
            },
          }),
          _vm._t("note"),
        ],
        2
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.errors.length
          ? _c(
              "div",
              { staticClass: "file-loader__errors" },
              _vm._l(_vm.errors, function (error, index) {
                return _c("c-error", { key: index, attrs: { text: error } })
              }),
              1
            )
          : _vm._e(),
      ]),
      _c("FsLightbox", {
        key: _vm.gallery.length,
        attrs: {
          toggler: _vm.lightbox,
          sources: _vm.gallery,
          slide: _vm.slide,
          "disable-local-storage": true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }